module.exports = __webpack_public_path__ + "assets/logo.be02b096.svg";